import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { PostsType } from '../../../../../types/posts';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

import { Props } from './Drafts';

type StateProps = Pick<Props, 'streamId' | 'items' | 'hasMore' | 'isFetching'>;
type DispatchProps = Pick<Props, 'fetchMore'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const draftsStreamId = getPostsDeviationsStreamId({
    type: PostsType.DRAFTS,
    sortOrder: ownProps.sortOrder,
  });
  const drafts = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, draftsStreamId)
  );

  return {
    streamId: draftsStreamId,
    items: drafts,
    hasMore: streamSelectors.hasMore(state, draftsStreamId),
    isFetching: streamSelectors.isFetching(state, draftsStreamId),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => {
  const draftsStreamId = getPostsDeviationsStreamId({
    type: PostsType.DRAFTS,
    sortOrder: ownProps.sortOrder,
  });
  return {
    fetchMore: () => dispatch(withOffset.actions.fetch(draftsStreamId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
